export const SUCCESS_LIBRARY_TOPIC = "SUCCESS_LIBRARY_TOPIC";
export const LOADING_LIBRARY_TOPIC_SEARCH = "LOADING_LIBRARY_TOPIC_SEARCH";

export const TopicTypes = {
  LOADING_LIBRARY_TOPIC_SEARCH,
  SUCCESS_LIBRARY_TOPIC
};
